import React from 'react';
import styled from 'styled-components';

import { AnimatedLoadingPlaceholder } from '../../../../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';
import { smallMediaQuery } from '../../../../../common/utilities/sizeHelpers';

export const AdUnitLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder height='100%' />
        </Container>
    );
};

const Container = styled.li`
    display: flex;
    width: 300px;
    height: 250px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 4px;
    @media ${smallMediaQuery} {
        margin: 4px 0;
    }
`;